import { FormGroup } from '@angular/forms';
import { DashboardFilter } from './shared/models/dashboard-filter';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { AppPageComponent } from '../shared/ui/app-page/app-page.component';
import { DashboardFilterSheetComponent } from './shared/ui/dashboard-filter-sheet';
import { Store, StoreHelper, UserService } from '../shared/services';
import { HeaderAction, TopLevelComponent, User } from '../shared/models';
import { Subscription } from 'rxjs/Subscription';

@Component({
  template: require('./dashboard.component.pug'),
})
export class DashboardComponent extends TopLevelComponent implements OnInit, OnDestroy {
  @ViewChild(AppPageComponent) appPage;
  @ViewChild(DashboardFilterSheetComponent) filterSheet;

  fg = new FormGroup({});
  dashboardFilter: DashboardFilter;

  private _calendarAction = { id: 'calendar', icon: 'calendar' };
  private _userSubscription: Subscription;
  private _user: User;
  private _initialFilter = true;

  constructor(
    store: Store,
    storeHelper: StoreHelper,
    userService: UserService) {
    super(store, storeHelper, userService);
  }

  ngOnInit() {
    this.headerTitle = 'Dashboard';
    this.headerActions = [this._calendarAction];
    this.subscribeToHeaderActions(this._reactToHeaderAction);

    let that = this;

    this._userSubscription = this.userService.user$.subscribe(user => {
      that._user = user;
    });
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }

  onFilterChanged(filter: DashboardFilter) {
    if (this._user != null) {
        this.dashboardFilter = filter;

        if (!this._initialFilter) {
            this.filterSheet.toggle();
        }

        this._initialFilter = false;
    }
  }

  private _reactToHeaderAction(action: HeaderAction) {
    if (action.id === this._calendarAction.id) {
       this.filterSheet.toggle();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/dashboard.component.ts